import type { LabelVariant } from '../../../label/LabelVariant';
import { mainTheme } from '../../../themes/mainTheme';

export const RED_THRESHOLD = 40;

export const getProgressColor = (percent: number): string => {
	if (percent >= 100) return mainTheme.progress.success;
	if (percent < RED_THRESHOLD) return mainTheme.progress.danger;
	return mainTheme.progress.warning;
};

export const getVariantFromPercent = (percent: number): LabelVariant => {
	if (percent >= 100) return 'success';
	if (percent < RED_THRESHOLD) return 'critical';
	return 'warning';
};
